import React from "react";
import { useTranslation } from "react-i18next";
import QRCodeSettings from "~/components/QRCodeSettings";
import Accordion from "~/components/utils/Accordion";

/**
 * 二次元コード設定セクションコンポーネント
 * @returns 二次元コード設定セクションのJSX要素
 */
const QRCodeSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: `${t("qrCode")}`,
          content: <QRCodeSettings />,
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default QRCodeSection;
